import { Store } from "utilities/Redux/store"

export const getImageById = (state: Store, id: string) =>
  state.images[id] ? state.images[id] : undefined
